import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useStore } from "../context/StoreContext";
import api from "../lib/api";
import ProductCard from "../components/ProductCard";

export default function Wishlist() {
  const { wishlist } = useStore();
  const [all, setAll] = useState([]);
  useEffect(() => { api.get("/products").then(r => setAll(r.data)).catch(() => {}); }, []);
  const products = all.filter(p => wishlist.includes(p.slug));

  return (
    <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-14 min-h-[60vh]">
      <span className="eyebrow text-moss">Saved</span>
      <h1 className="serif text-5xl mt-2 mb-10">Your Wishlist</h1>
      {products.length === 0 ? (
        <div className="py-20 text-center"><p className="serif text-3xl text-forest/60 mb-6">Save what speaks to you.</p><Link to="/shop" className="btn-primary">Explore Collection</Link></div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-5 gap-y-12">{products.map((p, i) => <ProductCard key={p.slug} product={p} index={i} />)}</div>
      )}
    </div>
  );
}
